import type { AccessResource } from '../../types/accessControl/accessResource.types';
import { ACCESS_FEATURE } from './accessFeatures';
import { LINK_LEVEL_SETTINGS } from './accessResource';

export const ACCESS_FEATURE_RESOURCE: Record<string, AccessResource> = {
  [ACCESS_FEATURE.TEMPLATE_ONLY]: LINK_LEVEL_SETTINGS,
};
